<div class="animated fadeInRight main-view-big" style="padding: 24px;">
  <div class="row no-padding" style="margin-bottom: 16px; display: flex; align-items: center; gap: 24px;">
    <mat-checkbox color="primary" [(ngModel)]="this.IsNewPassword" (change)="resetisnewpassword()">
      {{'Stammdaten.Neueskennwortvergeben' | translate}}
    </mat-checkbox>
    <mat-checkbox color="primary" [(ngModel)]="this.IsNewEmail" (change)="resetisnewemail()">
      {{'Stammdaten.Emailwechsel' | translate}} {{this.oroservice.kundeninfo.Email}}
    </mat-checkbox>
  </div>

  @if (this.IsNewPassword) {
    <div class="row no-padding" style="margin-top: 8px;">
      <div class="col-md-4 col-left">
        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
          <mat-label>{{'Stammdaten.AltesKennwort' | translate}}</mat-label>
          <input matInput type="password" [(ngModel)]="this.userdaten.AltesKenntwort" required autocomplete='off' placeholder="{{'RequiredPlaceholder' | translate}}">
        </mat-form-field>
      </div>
      <div class="col-md-4 col-middle">
        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
          <mat-label>{{'Stammdaten.NeuesKennwort' | translate}}</mat-label>
          <input matInput type="password" [(ngModel)]="this.userdaten.NeuesKenntwort" required autocomplete='off' placeholder="{{'RequiredPlaceholder' | translate}}">
        </mat-form-field>
      </div>
      <div class="col-md-4 col-right">
        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
          <mat-label>{{'PasswortRepeat' | translate}}</mat-label>
          <input matInput type="password" [(ngModel)]="this.userdaten.NeuesKenntwort2" required autocomplete='off' placeholder="{{'RequiredPlaceholder' | translate}}">
        </mat-form-field>
      </div>
      @if (this.userdaten.NeuesKenntwort != this.userdaten.NeuesKenntwort2) {
        <mat-warning>
          {{'Login.Passwortgleich' | translate}}
        </mat-warning>
      }
      <div class="row no-padding" style="margin-top: 8px;">
        <button mat-flat-button color="primary" class="button-standard" (click)="this.SaveSettings()" [disabled]="!canSubmit()">
          <mat-icon>save</mat-icon>
          {{'Speichern' | translate}}
        </button>
      </div>
    </div>
  }

  @if (this.IsNewEmail) {
    <div class="row no-padding" style="margin-top: 8px;">
      <div class="col-md-12 col-left">
        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
          <mat-label>{{'Stammdaten.NeueEmail' | translate}}</mat-label>
          <input matInput [(ngModel)]="NeueEmail" required placeholder="{{'RequiredPlaceholder' | translate}}" type="text">
        </mat-form-field>
      </div>
      <div class="col-md-12 col-left" style="margin-top: 8px;">
        <button mat-button color="primary" class="button-standard" (click)="this.GetNewEmail()" [disabled]="!NeueEmail || !validateemail(NeueEmail)">
          <mat-icon>alternate_email</mat-icon>&nbsp;
          {{'Stammdaten.EmailAendern' | translate}}
        </button>
      </div>
    </div>
  }
</div>
